// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-a3f2fba4] {\n  width: 90vw;\n}\n.rounded-3[data-v-a3f2fba4] {\n  background-color: #f2f2f2;\n}\n.image-area[data-v-a3f2fba4] {\n  width: auto;\n  max-height: 40%;\n  max-width: 90%;\n}\n#serialNo[data-v-a3f2fba4] {\n  font-size: 150%;\n}\n#vinNo[data-v-a3f2fba4] {\n  font-size: 150%;\n}\n#selectFile[data-v-a3f2fba4] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
